import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

const LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON = {
  noContext: 'No scenario context available',
  noEntity: 'No current record available',
} as const

/**
 * Relays a request for the current record to a self-contained functional-usage
 * request with record and scenario context.
 */
export const loadForCurrentEntity = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.loadForCurrentEntity.relay(forwardTo =>
      rxjs
        .combineLatest([
          plugin.collection.plugins.currentEntityPlugin.feature.selectors.getId()
            .asObservable,
          plugin.collection.feature.selectors.context.asObservable,
        ])
        .pipe(
          rxjs.take(1),
          rxjs.map(([spaceRecordId, context]) => {
            if (!ents.extra.space.Record.Id.isId(spaceRecordId)) {
              return {
                cancellation: {
                  reason: LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON.noEntity,
                },
              }
            }

            if (!ents.core.admin.Context.ForScenario.isForScenario(context)) {
              return {
                cancellation: {
                  reason: LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON.noContext,
                },
              }
            }

            return forwardTo(feature.actions.load, {
              input: { context, spaceRecordId },
              output: () => undefined,
            })
          }),
        ),
    ).asObservable,
)
